<div class="c__wrapper">
  <ul sd-list-inline>
    @for (legend of legends; track legend) {
      <li>
        <sd-icon #mapLegends
          [id]="legend.id"
          [class]="legend.isBrand ? 'is-brand' : ''"
          [size]="iconSize"
          [name]="legend.iconName"
          [placeholder]="legend.iconName"
        />
        <p>{{ legend.description | translate }}</p>
      </li>
    }
  </ul>
</div>
